import { EVENTS } from '../constants/webSocketConsts/events';
import { setTasksAction } from '../store/tasks/actions';

const OnBoardingTasksHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.MODIFY:
      return setTasksAction(items);
    default:
      break;
  }
  return null;
};

export default OnBoardingTasksHandler;
